import { ClusterKey } from "./cluster-key.model";
import { ClusterProduct } from "./cluster-product.model";

export class Cluster {
  constructor(
    private clusterKey: ClusterKey,
    private name: string,
    private totalProducts: number,
    private createdDate: string,
    private lastChangeDate: string,
    private clusterProducts: Array<ClusterProduct>,
  ) {}

  public getClusterKey(): ClusterKey {
    return this.clusterKey;
  }

  public getName(): string {
    return this.name;
  }

  public getCreatedDate(): string {
    return this.createdDate;
  }

  public getProductCount(): number {
    return this.totalProducts;
  }

  public getClusterProducts(): Array<ClusterProduct> {
    return this.clusterProducts;
  }

  public getLastChangeDate(): string {
    return this.lastChangeDate;
  }

  public setLastChangeDate(lastChangeDate: string): void {
    this.lastChangeDate = lastChangeDate;
  }

  public setClusterKey(value: ClusterKey): void {
    this.clusterKey = value;
  }

  public setName(value: string) {
    this.name = value;
  }

  public setCreatedDate(value: string) {
    this.createdDate = value;
  }

  public setProductCount(value: number) {
    this.totalProducts = value;
  }

  public setClusterProducts(clusterProducts: Array<ClusterProduct>): void {
    this.clusterProducts = clusterProducts;
  }
}
